export const THEME_STORAGE_KEY = 'theme-preference';
export type Theme = 'dark' | 'light';
